import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function RegisteredWithSuccess() {
  const navigate = useNavigate();

  const handleConfirmButton = () => {
    navigate('/login');
  };

  return (
    <main className="d-flex w-100 h-100 login-background">
      <div className="container d-flex flex-column">
        <div className="vh-100">
          <div className="mx-auto d-table h-100 w-50">
            <div className="d-table-cell align-middle">
              <Box className="mx-auto text-center mb-3">
                <img
                  className="img-fluid mb-4"
                  width="180"
                  height="48"
                  src="/img/logo.png"
                  alt="BUILD-SELF"
                />
                <h2 className="text-bold my-2">
                  Registration complete
                </h2>

                <Box className="card">
                  <Box className="card-body">
                    <Typography
                      textAlign="left"
                      fontSize={12}

                    >
                      Thank you for registering. Please keep your login password safe. Registration is complete; continue using our service.
                      <br />
                      <br />
                      To upgrade to a paid plan, go to Plan Settings in Account Management after login.
                      <br />
                      <br />
                    </Typography>

                    <Button
                      sx={{
                        fontSize: '0.8rem',
                      }}
                      onClick={handleConfirmButton}
                      variant="contained"
                    >
                      Login
                    </Button>
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default RegisteredWithSuccess;
